import React, { Component } from 'react';
import styled from 'styled-components';
import { Trail } from 'react-spring';
import header from '../assets/header.png';
import { Tap } from '../dooh-react-utils';
import preloader from '../preload';
import queryString from 'query-string';
import { questions } from '../questions';
import { shuffle } from '../random';

let qs = queryString.parse(window.location.search);
let QUESTION = parseInt(qs.question, 10) - 1;
if (!Number.isFinite(QUESTION) || QUESTION < 0 || QUESTION >= questions.length)
  QUESTION = null;

let CURRENT = 0;

const Wrap = styled.div`
  color: black;
  height: 1920px;
  width: 1080px;
  position: absolute;

  #bg, #overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 1080px;
    height: 1920px;
  }

  #bg {
    pointer-events: none;
  }

  #overlay {
    background: #8af1a4 url('${preloader.get(header)}') no-repeat 50% 50px;
  }
`;

const Answers = styled.div`
  font-size: 40px;
  display: flex;
  margin-top: 60px;
  width: 100%;
  flex-direction: column;
`;

const Answer = styled(Tap)`
  font-family: Garamond;
  width: 820px;

  & > div {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    color: black;
    background: #ffd82b;
    margin: 0 auto;
    font-size: 42px;
    font-family: RalewayBold, sans-serif;
    border: 6px solid black;
    min-height: 150px;
    border-radius: 100px;
    font-weight: 700;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
  }

  box-sizing: border-box;
  margin: 10px auto;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
`;

const Header = styled.div`
  margin-top: 320px;
  margin-bottom: 30px;
  color: black;
  text-align: center;
  font-size: 80px;
  font-family: Gagalin-Regular;
`;

const Question = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 0 80px;
  font-size: 80px;
  font-family: Gagalin-Regular;
  text-align: center;
`;

let VIDEO_EL = null;

function videoTimeUpdate(e, done) {
  VIDEO_EL = e.target;
}

class Screen extends Component {
  constructor(props) {
    super(props);
    let questions = props.questions;
    let qa = questions.slice(0, 15);
    let qb = questions.slice(15, 30);
    shuffle(qa);
    shuffle(qb);

    if (QUESTION != null) questions = [questions[QUESTION]];
    if (qs.TEST == null) questions = [...qa.slice(0, 3), ...qb.slice(0, 2)];

    this.state = {
      questions,
      score: 0,
      current: CURRENT,
      time: +new Date(),
      selectedAnswer: null,
      phase: 'NOT_ANSWERED', // ANSWERED, TIMEOUT
      done: false,
    };
  }

  componentDidMount() {
    //this.setState(this.nextQuestion);
    this.nextQuestionTimeout = null;
  }

  render() {
    let { questions, current } = this.state;
    let q = questions[current];

    return (
      <Wrap>
        <div id="overlay">
          <Header>
            {current + 1}/{questions.length}
          </Header>

          <Question style={{ fontSize: `${q.fontSize}px` }}>
            {q.question()}
          </Question>

          <Answers>
            <Trail
              items={q.answers}
              keys={item => `${current}/${item.i}`}
              from={{ opacity: 0, transform: 'translate3d(0, -20px, 0)' }}
              to={{ opacity: 1, transform: 'translate3d(0, 0px, 0)' }}
            >
              {item => style => this.getAnswer(item, style)}
            </Trail>
          </Answers>
        </div>
        <video
          id="bg"
          onTimeUpdate={e => videoTimeUpdate(e, this.state.done)}
          src={preloader.get(
            this.state.done
              ? require('../assets/bubble-exit.webm')
              : require('../assets/bubble.webm')
          )}
          muted
          autoPlay
          loop={!this.state.done}
        />
      </Wrap>
    );
  }

  getAnswer = (answer, style) => {
    let styl = { ...style };

    let selected = this.state.selectedAnswer;

    if (selected === answer.i) {
      styl['background'] = 'white';
    }

    return (
      <Answer
        className={answer.cls}
        key={`${this.state.current}/${answer.a}`}
        onTap={() => this.answer(answer)}
        icon={answer.icon}
        preventDoubleTap={false}
      >
        <div style={styl}>{answer.a}</div>
      </Answer>
    );
  };

  answer = a => {
    if (this.state.phase !== 'NOT_ANSWERED') return;
    const dt = +new Date() - this.state.time;
    if (dt < 500) return;

    this.setState(s => ({
      ...s,
      phase: 'ANSWERED',
      score: s.score + (a.correct ? 1 : 0),
      selectedAnswer: a.i,
    }));

    if (this.state.current === this.state.questions.length - 1) {
      setTimeout(() => {
        this.setState({ done: true });

        setTimeout(() => {
          window.track('submit', {
            score: this.state.score,
            age: this.props.age,
          });
          this.nextScreen();
        }, 3000);

        if (VIDEO_EL) {
          VIDEO_EL.currentTime = 0;
        }
      }, 500);
    } else {
      this.nextQuestionTimeout = setTimeout(
        () => this.setState(this.nextQuestion),
        600
      );
    }
  };

  nextQuestion = s => {
    return {
      ...s,
      current: s.current + 1,
      selectedAnswer: null,
      phase: 'NOT_ANSWERED',
      time: +new Date(),
    };
  };

  nextScreen = () => {
    this.setState({ phase: 'TIMEOUT' });

    console.log(this.state.score);
    this.props.update(s => ({
      ...s,
      score: this.state.score,
    }));

    this.props.gotoNextScreen();
  };
}

export default Screen;
